import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

export function futureDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value) {
      const controlDate = new Date(value);
      const today = new Date();

      today.setHours(0, 0, 0, 0);

      if (controlDate <= today) {
        return { futureDate: true };
      }
    }

    return null;
  };
}
